import React from 'react';
import PropTypes from 'prop-types';
import {
  GoPaperlessPolicyPreferenceContainer,
  PolicyEmailAddress,
  PolicyLabelMobile,
  PolicyMailingAddress,
  PolicyNumberLabel,
  PolicySummary,
  PreferenceLabelMobile,
  PreferenceRadioEmail,
  PreferenceRadioMail,
  ProfileEditorsContainer,
  ProfileRadioButtonContainer,
} from './styles';
import { getText } from '../../../utils/i18n';

export const CustomerDeliveryPreferences = (props) => {
  const {
    customerAddress,
    customerDeliveryPreference,
    customerEmail,
    editingDeliveryPreferences,
    i18n,
    isLoading,
    setCustomerDeliveryPreference,
  } = props;

  const goPaperlessMissingEmailHelperText = getText(
    i18n,
    'policyDetails.helper.missingEmailText',
    'No email address found. Please add an email address to your policy if you wish to select paperless.',
  );

  return (
    <GoPaperlessPolicyPreferenceContainer $index={'customer_communications'}>
      <PolicySummary>
        <PolicyLabelMobile>All Other Customer Communications</PolicyLabelMobile>
        <PolicyNumberLabel>All Other Customer Communications</PolicyNumberLabel>
        <PolicyEmailAddress>
          Email: {customerEmail ? customerEmail : goPaperlessMissingEmailHelperText}
        </PolicyEmailAddress>
        <PolicyMailingAddress>
          Address:{' '}
          {`${customerAddress.addr1} ${customerAddress.city} ${customerAddress.stateProvCd} ${customerAddress.postalCode}`}
        </PolicyMailingAddress>
      </PolicySummary>
      <ProfileEditorsContainer>
        <PreferenceLabelMobile>Preference</PreferenceLabelMobile>
        <ProfileRadioButtonContainer>
          <PreferenceRadioEmail>
            <label htmlFor="radioEmailCustomer">
              <input
                aria-label={`Preference for all other Customer communications Paperless`}
                type="radio"
                name={'deliveryPref_customer'}
                value="Email"
                id="radioEmailCustomer"
                onChange={(e) => setCustomerDeliveryPreference(e.target.value)}
                checked={customerDeliveryPreference === 'Email'}
                disabled={isLoading || !editingDeliveryPreferences || !customerEmail}
              />{' '}
              Paperless
            </label>
          </PreferenceRadioEmail>
          <PreferenceRadioMail>
            <label htmlFor="radioBatchCustomer">
              <input
                aria-label={`Preference for all other Customer communications Mail`}
                type="radio"
                name={'deliveryPref_customer'}
                value="Batch"
                id="radioBatchCustomer"
                onChange={(e) => setCustomerDeliveryPreference(e.target.value)}
                checked={customerDeliveryPreference === 'Batch'}
                disabled={isLoading || !editingDeliveryPreferences}
              />{' '}
              Mail
            </label>
          </PreferenceRadioMail>
        </ProfileRadioButtonContainer>
      </ProfileEditorsContainer>
    </GoPaperlessPolicyPreferenceContainer>
  );
};

CustomerDeliveryPreferences.propTypes = {
  customerAddress: PropTypes.object,
  customerDeliveryPreference: PropTypes.string,
  customerEmail: PropTypes.string,
  editingDeliveryPreferences: PropTypes.bool,
  i18n: PropTypes.object,
  isLoading: PropTypes.bool,
  setCustomerDeliveryPreference: PropTypes.func,
};
export default CustomerDeliveryPreferences;
